import {Component} from '@angular/core';
import {Konzern} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';
import {WizardPageBaseComponent} from '@utils-lib';

@Component({
  selector: 'common-ui-konzern-angaben',
  templateUrl: './konzern-angaben.component.html'
})
export class KonzernAngabenComponent extends WizardPageBaseComponent<Konzern> {

  static nutzdatenPath = 'konzernAngaben';
  static route = 'konzern-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown> {
    return new Map<string, unknown | Array<unknown>>([]);
  }

}
